import api from "./api";

/**
 * Agregacao geografica dos cadastros de uma equipe, usada pelo mapa de calor
 * (/analise/mapa-calor).
 */
class MapaCalorAPI {
  /**
   * Traz os tres niveis (bairro, municipio, regiao) numa unica requisicao.
   *
   * @param {Object} headers  Helpers.getHeaderRequisicao()
   * @param {Object} params   { equipe: idcandidato, posicionar_por_zona: 0|1 }
   *   posicionar_por_zona=1 posiciona pela zona eleitoral os cadastros cuja
   *   secao nao existe na base de secoes (so nos niveis municipio e regiao, e
   *   apenas quando a zona corresponde a um unico deles).
   * @returns {Promise} { equipe, totais, areas: { bairro, municipio, regiao }, token }
   */
  async getMapaCalor(headers, params) {
    return await api.get("/mapa_calor", { params, headers });
  }
}

export default new MapaCalorAPI();
